<template lang="pug">
  BaseForm(
    :title="title"
    :routeKey="routeKey"
    :routes="routes"
    :form="form"
    :data="item"
    :update="updateItem"
    :create="createItem"
  )
</template>

<script>
import BaseForm from '@/components/app/BaseForm'
import { mapState, mapActions } from 'vuex'
import store from '@/store'

export default {
  components: { BaseForm },
  data: (vm) => ({
    title: vm.$t('socials.create')
  }),
  computed: {
    ...mapState('socials', ['routeKey', 'routes', 'form', 'item']),
    crumbs: (vm) => [
      { text: vm.$t('socials.title'), to: { name: 'socials.index' } },
      { text: vm.$t('socials.create') }
    ]
  },
  async beforeRouteEnter (to, from, next) {
    try {
      await store.dispatch('socials/clearItem')
      await store.dispatch('socials/fetchSiteVersions')
      next()
    } catch (error) {
      next(error)
    }
  },
  methods: {
    ...mapActions('socials', ['createItem', 'updateItem'])
  }
}
</script>
